export class MergeRequest {
	
	sourceBatchIds: string[];

	mergedBatchId: string;

    userID: string;

    labId: string;

    pcrPlateID: string;

    sourceBatchIdMap: any;

    workflowGroup: string;

    tagSystemName: string;

    product: string;

}